;
(function (ng) {
  'use strict';

  angular.module('transformer', []);
})(window.angular);